import React, {createContext, FC, useContext, useEffect} from "react";
import {SystemResponse} from "../Responses/SystemResponse";
import {API} from "../API";
import {AxiosResponse} from "axios/index";
import {useErrorHandler} from "react-error-boundary";
import {APILink} from "../APILink";

export type SystemContextProps = {
    children?: React.ReactNode
}

export interface SystemInterface {
    setInfo: (r: SystemResponse) => void
    system: SystemResponse | undefined
}

// create context
const SystemContext = createContext<SystemInterface | null>(null);

const useSystemContext = () => {
    const context = useContext(SystemContext);

    if (context === undefined) {
        throw new Error("useSystemContext was used outside of its Provider");
    }

    return context;
};

const SystemContextProvider: FC<SystemContextProps> = ({children}: SystemContextProps) => {
    const [system, setInfo] = React.useState<SystemResponse>();
    const handleError = useErrorHandler();

    useEffect(() => {
        if (localStorage.getItem('userToken')) {
            API.getSystem().then((response: AxiosResponse) => {
                setInfo(response.data as SystemResponse);
            }).catch(e => {
                handleError(e);
                API.removeURL(`get${APILink.GET_SYSTEM}`);
            });
        }
    }, [handleError]);

    return (
        <SystemContext.Provider value={{system, setInfo}}>
            {children}
        </SystemContext.Provider>
    );
};

export {useSystemContext, SystemContextProvider};
